function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyledCardComponent } from "./card-component.scss";
import AssetComponent from "components/core/asset/asset-component";
import FullParagraph from "segments/desktop/core-components/full-paragraph/full-paragraph";
import Testimonial from "segments/desktop/core-components/testimonial/testimonial";
import SecondaryButton from "segments/desktop/core-components/button/secondary-button/secondary-button";
import { PrevArrowIcon } from "./prev-arrow-icon";
import { NextArrowIcon } from "./next-arrow-icon";
const DEFAULT_STAT_CONTENT = {
    topic: {}
};
const CardComponent = ({ testimonial, advancedStatsConfig, stats, onPrevClick, onNextClick, tabTitleImage, cardImageHeight })=>{
    var _testimonial_button, _testimonial_button1, _testimonial_button2;
    return /*#__PURE__*/ _jsxs(StyledCardComponent, {
        className: "card-component",
        cardImageHeight: cardImageHeight,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "tab-title",
                children: [
                    /*#__PURE__*/ _jsx(AssetComponent, {
                        image: {
                            src: tabTitleImage
                        }
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "carousel-arrows",
                        children: [
                            /*#__PURE__*/ _jsx(PrevArrowIcon, {
                                onClick: onPrevClick
                            }),
                            /*#__PURE__*/ _jsx(NextArrowIcon, {
                                onClick: onNextClick
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "stats-section",
                children: stats === null || stats === void 0 ? void 0 : stats.map((statics, index)=>/*#__PURE__*/ _jsxs("div", {
                        className: "stats",
                        children: [
                            /*#__PURE__*/ _jsx(FullParagraph, _object_spread({}, DEFAULT_STAT_CONTENT, statics, advancedStatsConfig)),
                            index < stats.length - 1 && /*#__PURE__*/ _jsx("div", {
                                className: "vertical-line"
                            })
                        ]
                    }, index))
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "testimonial-wrapper",
                children: [
                    /*#__PURE__*/ _jsx(Testimonial, _object_spread({}, testimonial)),
                    (testimonial === null || testimonial === void 0 ? void 0 : testimonial.button) && /*#__PURE__*/ _jsx(SecondaryButton, {
                        isWithArrow: true,
                        color: (_testimonial_button = testimonial.button) === null || _testimonial_button === void 0 ? void 0 : _testimonial_button.color,
                        url: (_testimonial_button1 = testimonial.button) === null || _testimonial_button1 === void 0 ? void 0 : _testimonial_button1.buttonUrl,
                        buttonText: (_testimonial_button2 = testimonial.button) === null || _testimonial_button2 === void 0 ? void 0 : _testimonial_button2.buttonText,
                        isOpenLinkInNewTab: true
                    })
                ]
            })
        ]
    });
};
export default CardComponent;
